import PropTypes from 'prop-types';
// @mui
import Avatar from '@mui/material/Avatar';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';
import { Button } from '@mui/material';
import Iconify from 'src/components/iconify';
import { useState } from 'react';
// components

// ----------------------------------------------------------------------

export default function FileManagerInvitedItem({ person, shareButton }) {

  // const [permission, setPermission] = useState(person.permission);

  // const popover = usePopover();

  // const handleChangePermission = useCallback((newPermission) => {
  //   setPermission(newPermission);
  // }, []);

  const [selected, selectedSet] = useState([]);

  const handleSelected = () => {
    if (selected.includes(person.id)) {
      selectedSet(selected.filter((id) => id !== person.id));
    } else {
      selectedSet([...selected, person.id]);
    }
  }

  return (
    <>
      <ListItem
        sx={{
          px: 0,
          py: 1,
          ...(selected.includes(person.id) && {
            bgcolor: 'action.selected',
            borderRadius: 1,
            
           }),
        }}
      >
        <Avatar alt={person.name} src={person.avatarUrl} sx={{ mr: 2 }} />

        <ListItemText
          primary={person.name}
          secondary={
            <Tooltip title={person.email}>
              <span>{person.email}</span>
            </Tooltip>
          }
          primaryTypographyProps={{ noWrap: true, typography: 'subtitle2' }}
          secondaryTypographyProps={{ noWrap: true, component: 'span' }}
          sx={{
            flexGrow: 1, pr: 1,

          }}
        />
        {shareButton &&
          <Iconify icon={selected.includes(person.id) ? "stash:minus-solid" : "stash:plus-solid"} width={20} height={20} sx={{ cursor: "pointer" }} onClick={handleSelected} />
        }

        {/* <Button
          size="small"
          color="inherit"
          endIcon={
            <Iconify
              width={20}
              icon={popover.open ? 'eva:arrow-ios-upward-fill' : 'eva:arrow-ios-downward-fill'}
              sx={{ ml: -1 }}
            />
          }
          onClick={popover.onOpen}
          sx={{
            flexShrink: 0,
            ...(popover.open && {
              bgcolor: 'action.selected',
            }),
          }}
        >
          Can {permission}
        </Button> */}
      </ListItem>

      {/* <CustomPopover open={popover.open} onClose={popover.onClose} sx={{ width: 160 }}>
        <>
          <MenuItem
            selected={permission === 'view'}
            onClick={() => {
              popover.onClose();
              handleChangePermission('view');
            }}
          >
            <Iconify icon="solar:eye-bold" />
            Can view
          </MenuItem>

          <MenuItem
            selected={permission === 'edit'}
            onClick={() => {
              popover.onClose();
              handleChangePermission('edit');
            }}
          >
            <Iconify icon="solar:pen-bold" />
            Can edit
          </MenuItem>

          <Divider sx={{ borderStyle: 'dashed' }} />

          <MenuItem
            onClick={() => {
              popover.onClose();
            }}
            sx={{ color: 'error.main' }}
          >
            <Iconify icon="solar:trash-bin-trash-bold" />
            Remove
          </MenuItem>
        </>
      </CustomPopover> */}
    </>
  );
}

FileManagerInvitedItem.propTypes = {
  person: PropTypes.object,
};
